import { useReactiveVar } from "@apollo/client";
import { user as userVar } from "apollo/cache";

export function useRole() {
  const user = useReactiveVar(userVar);
  const role = user?.role ?? null;
  const country = user?.country ? user.country.toLocaleLowerCase() : "th";
  const isFeature = {
    dashboard: country.toLocaleLowerCase() !== "vi",
    notification: true,
    shareLine: country.toLocaleLowerCase() !== "vi",
    autoYellow: true
    // averageLength: false
  };

  return {
    role,
    country,
    isFeature,
  };
}

export default useRole;
